<template>
    <div
        class="side-nav-panel flex flex-col overflow-hidden border-r border-ds-primary-200 bg-ds-primary-50 pt-2 transition-all duration-200 ease-in-out"
        :class="companyNavigationStore.showSideNav ? 'w-[75vw] legacy-md:w-64' : 'w-0 legacy-md:w-16'"
    >
        <div class="mb-2 flex justify-end">
            <div
                class="expansion-control-shadow -border hidden w-5 cursor-pointer items-center rounded-l-[4px] bg-ds-primary-100 py-1 text-center hover:bg-ds-primary-200 legacy-md:inline-block"
                @click="companyNavigationStore.toggleSideNav"
            >
                <DsIcon
                    class="text-ds-primary-400"
                    :icon="companyNavigationStore.showSideNav ? 'fa-solid fa-chevron-left' : 'fa-solid fa-chevron-right'"
                    size="sm"
                />
            </div>
        </div>

        <slot />
    </div>
</template>

<script setup lang="ts">
import DsIcon from '@/components/design-system/DsIcon.vue';
import { TOGGLE_SIDE_NAV_HOTKEY, useCompanyNavigationStore } from '@/stores/company/company-navigation.store';
import hotkeys from 'hotkeys-js';
import { onMounted, onUnmounted } from 'vue';

const companyNavigationStore = useCompanyNavigationStore();

onMounted(() => {
    hotkeys(TOGGLE_SIDE_NAV_HOTKEY, () => {
        companyNavigationStore.toggleSideNav();
    });
});

onUnmounted(() => {
    hotkeys.unbind(TOGGLE_SIDE_NAV_HOTKEY);
});
</script>

<style scoped lang="scss">
.side-nav-panel {
    @media screen and (max-width: 767px) {
        padding-top: calc(8px + env(safe-area-inset-top, 0px));
        padding-bottom: env(safe-area-inset-bottom, 0px);
    }
}

.expansion-control-shadow {
    box-shadow:
        0px 1px 2px -1px rgba(16, 24, 40, 0.1),
        0px 1px 3px 0px rgba(16, 24, 40, 0.1);
}
</style>
